import { areDocumentsAvailable } from "../components/Dashboard/DocumentList";

export const calculateDocumentStatus = (data) => {
    if (!data || typeof data !== 'object') return 0;
    
    const keysToCheck = [
        "bankDetails",
        "complianceAndOtherDocuments",
        "gdprJobApplicationProcessingConsentForm",
        "literacyAndNumeracyAssessment",
        "healthQuestionnaire",
        "lfukKidForPaye",
        "gdprPolicy",
        "lfuk48hrOptOutForm",
        "lfukRecruitmentServicesLimitedTermsOfEngagement",
        "newStarterChecklist",
        "workExperience"
    ];

    const totalSections = keysToCheck.length;
    let completedSections = 0;

    keysToCheck.forEach(key => {
        const value = data[key];

        if (key === "complianceAndOtherDocuments") {
            if (value && areDocumentsAvailable(value?.uploadedDocuments)) {
                if (value.progress === 100) {
                    completedSections++;
                }
            }
        } else if (value && value.progress === 100) {
            completedSections++;
        }
    });

    return totalSections > 0 ? ((completedSections / totalSections) * 100).toFixed(2) : 0;
};
